import { useEffect, useState } from "react";
import { ThumbsUp, ThumbsDown, MessageSquareText } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle } from "./AdminAnalytics";

const fmt = (ts) => new Date(ts).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
const Stat = ({ label, value, testId }) => (
  <div className="bg-white border border-[#E2DACF] p-5"><p className="text-[11px] tracking-[0.18em] uppercase text-[#8C8275]">{label}</p><p className="font-serif text-3xl mt-2 tabular-nums" data-testid={testId}>{value}</p></div>
);

export default function AdminConsultant() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/consultant/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <p className="text-[#8C8275]">Caricamento…</p>;
  return (
    <div data-testid="admin-consultant">
      <PageTitle eyebrow="Consulente AI" title="Domande e feedback" />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mt-6">
        <Stat label="Domande totali" value={s.total_questions} testId="consultant-stat-total" />
        <Stat label="Oggi" value={s.today} testId="consultant-stat-today" />
        <Stat label="Conversazioni" value={s.sessions} testId="consultant-stat-sessions" />
        <Stat label="Pollice su" value={s.thumbs_up} testId="consultant-stat-up" />
        <Stat label="Pollice giù" value={s.thumbs_down} testId="consultant-stat-down" />
      </div>
      <div className="grid lg:grid-cols-3 gap-6 mt-8">
        <div className="bg-white border border-[#E2DACF] p-6" data-testid="consultant-top-words">
          <p className="font-serif text-xl">Temi più frequenti</p>
          <p className="text-xs text-[#8C8275] mt-1">Parole ricorrenti nelle domande delle clienti.</p>
          <div className="flex flex-wrap gap-2 mt-4">
            {s.top_words.map(([w, n]) => <span key={w} className="text-xs border border-[#E6DFD5] px-2.5 py-1 bg-[#FAF8F5]">{w} <span className="text-[#8C8275]">×{n}</span></span>)}
            {!s.top_words.length && <p className="text-sm text-[#8C8275]">Ancora nessuna domanda.</p>}
          </div>
        </div>
        <div className="lg:col-span-2 bg-white border border-[#E2DACF] p-6" data-testid="consultant-recent">
          <p className="font-serif text-xl flex items-center gap-2"><MessageSquareText size={18} strokeWidth={1.5} /> Ultime domande</p>
          <ul className="divide-y divide-[#F2ECE4] mt-4">
            {s.recent.map((r) => (
              <li key={`${r.session_id}-${r.ts}`} className="py-4" data-testid="consultant-recent-item">
                <div className="flex items-start justify-between gap-3">
                  <p className="text-sm font-medium">{r.question}</p>
                  <span className="text-[11px] text-[#8C8275] whitespace-nowrap">{fmt(r.ts)} {r.vote === 1 ? <ThumbsUp size={12} className="inline text-[#2F6B3A]" /> : r.vote === -1 ? <ThumbsDown size={12} className="inline text-[#A0482F]" /> : null}</span>
                </div>
                {r.answer && <p className="text-xs text-[#595652] mt-2 leading-relaxed line-clamp-3">{r.answer}</p>}
              </li>
            ))}
            {!s.recent.length && <li className="py-6 text-sm text-[#8C8275]">Nessuna conversazione ancora.</li>}
          </ul>
        </div>
      </div>
      {s.negative.length > 0 && (
        <div className="bg-white border border-[#E2DACF] p-6 mt-6" data-testid="consultant-negative">
          <p className="font-serif text-xl">Risposte con pollice giù</p>
          <ul className="divide-y divide-[#F2ECE4] mt-4">
            {s.negative.map((r) => <li key={`${r.ts}-${r.question.slice(0, 20)}`} className="py-4"><p className="text-sm font-medium">{r.question}</p><p className="text-xs text-[#595652] mt-2 leading-relaxed">{r.answer}</p></li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
